// Componente RedirectToMenu.js
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../../Confg/firebaseConfig';

const RedirectToMenu = () => {
  const { alias } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      try {
        // Busca o link encurtado no Firestore
        const docRef = doc(db, "shortLinks", alias);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // Atualiza estatísticas
          await updateDoc(docRef, {
            clicks: increment(1),
            lastAccessed: new Date()
          });
          
          // Redireciona para o cardápio real
          navigate(docSnap.data().originalUrl);
        } else {
          navigate('/not-found'); // Página de erro se o link não existir
        }
      } catch (error) {
        console.error("Erro no redirecionamento:", error);
        navigate('/error');
      }
    };

    redirect();
  }, [alias, navigate]);

  return <div>Redirecionando...</div>;
};

export default RedirectToMenu;